import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { Box, Flex } from '@chakra-ui/react';
import PropType from 'prop-types';

import InputLabel from '../../../../../../components/form/InputLabel';
import { selectCompanyDepartments } from '../../../../../../redux/modules/company';
import UserRole from '../UserRole';

const UserRoles = ({ user }) => {
  const [userDepartmentRoles, setDepartmentRoles] = useState([]);
  const departments = useSelector(selectCompanyDepartments);

  useEffect(() => {
    const roles = user.roles || [];
    const departmentRoles = user.userId ? roles.filter(role => role.pivot.scopeType === 'department') : [];

    const displayRoles = {};
    departmentRoles.forEach(role => {
      // Roles can reference soft-deleted departments or departments of another company.
      const department = departments.find(dept => dept.departmentId === role.pivot.scopeId);
      if (!department) {
        return;
      }

      if (displayRoles[role.displayName]?.departmentNames.length) {
        displayRoles[role.displayName].departmentNames.push(department.departmentName);
      } else {
        displayRoles[role.displayName] = { departmentNames: [department.departmentName] };
      }
    });

    const displayRolesArray = Object.keys(displayRoles).map(key => {
      const roleName = key;
      const { departmentNames } = displayRoles[key];
      return { roleName, departmentNames };
    });

    setDepartmentRoles(displayRolesArray);
  }, [departments, user.roles, user.userId]);

  const companyRoleDisplayName = useMemo(() => {
    if (user.userId && user.roles?.length) {
      const companyRole = user.roles.find(role => role.pivot.scopeType === 'company');
      return companyRole?.displayName || 'No Roles';
    }

    return 'No Roles';
  }, [user]);

  return (
    <Box px={6} width="100%">
      <Flex justify="space-between" w="100%">
        <Flex direction="column" w="45%">
          {user.roles?.length > 0 && (
            <>
              <InputLabel labelName="Company Role" />
              <UserRole role={companyRoleDisplayName} />
            </>
          )}
        </Flex>
        <Flex direction="column" w="45%">
          {userDepartmentRoles.length ? (
            <>
              <InputLabel labelName="Department Roles" />
              {userDepartmentRoles.map(role => (
                <UserRole
                  departments={role.departmentNames}
                  key={role.roleName}
                  role={role.roleName}
                />
              ))}
            </>
          ) : ' '}
        </Flex>
      </Flex>
    </Box>
  );
};

UserRoles.propTypes = {
  user: PropType.shape({
    userId: PropType.number,
    roles: PropType.arrayOf(PropType.shape({
      pivot: PropType.shape({
        scopeType: PropType.string,
        scopeId: PropType.number
      })
    }))
  })
};

export default UserRoles;
